import {useTheme} from '@mui/material';

export default function ZoomInIcon() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.primary[900];
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path d="M9.19922 11.7H14.1992" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M11.6992 14.2V9.19995" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			<path
				d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
				stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M22 22L20 20" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
}
